"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactHookForm = require("react-hook-form");

var _ui = require("@alycecom/ui");

var _messaging = require("../../constants/messaging.constants");

var _messaging2 = require("../../constants/messaging.types");

var _RecipientActionsController = _interopRequireDefault(require("../RecipientActionsController"));

var styles = {
  header: {
    fontSize: 16,
    color: 'primary.main',
    fontWeight: 'bold'
  },
  actionLabel: {
    fontSize: 14,
    color: 'grey.main',
    fontWeight: 400
  }
};

var RecipientActions = function RecipientActions(_ref) {
  var campaign = _ref.campaign,
      control = _ref.control,
      resetField = _ref.resetField;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var canEditActions = campaign === null || campaign === void 0 ? void 0 : campaign.recipientActionOverrideEnabled;
  var recipientActions = (0, _reactHookForm.useWatch)({
    control,
    name: _messaging2.MessagingDataFields.RecipientActions
  });

  var toggleEditMode = function toggleEditMode() {
    return setEditMode(!editMode);
  };

  var hasRecipientActions = (0, _react.useMemo)(function () {
    return Object.values(recipientActions).some(Boolean);
  }, [recipientActions]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.header
  }, "Required actions to accept gift:"), canEditActions && /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: toggleEditMode
  }, editMode ? 'Close' : 'Edit')), editMode && /*#__PURE__*/_react.default.createElement(_RecipientActionsController.default, {
    control: control,
    resetField: resetField
  }), !editMode && hasRecipientActions && /*#__PURE__*/_react.default.createElement(_material.Box, null, Object.entries(_messaging.recipientActionLabels).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        type = _ref3[0],
        label = _ref3[1];

    var actionLabel = !!recipientActions[type];
    return actionLabel && /*#__PURE__*/_react.default.createElement(_material.Typography, {
      key: type,
      sx: styles.actionLabel
    }, label);
  })), !editMode && !hasRecipientActions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.actionLabel
  }, "No recipient actions")));
};

var _default = RecipientActions;
exports.default = _default;